import {action, computed, observable, makeObservable} from 'mobx';
import {history} from 'fn-common-ui';
import errorOrders from '../../../content/error-order.json';

export default class NewAppValidationsStore {

	constructor(master, details, upload) {
		makeObservable(this);
		this.masterStore = master;
		this.newAppDetailsStore = details;
		this.newAppUploadStore = upload;
	}

	// ACTIONS
	@action goToErrorField(error, parentPage, saveId) {
		this.errorDestination = error.field;
		this.masterStore.isGoingToError = true;
		if(parentPage) {
			history.push(`/new-application/${parentPage}/${saveId}`);
		}
	}

	// COMPUTEDS
	@computed get detailsErrorList() {
		let errorList = [];
		for(let field in this.newAppDetailsStore.inputFields) {
			if(this.newAppDetailsStore.inputFields[field].errorList.length > 0) {
				errorList.push({
					field: field,
					label: this.newAppDetailsStore.inputFields[field].label,
					error: this.newAppDetailsStore.inputFields[field].errorList[0],
					path: 'app-details'
				});
			}
		}
		for(let field in this.newAppDetailsStore.checkboxIsValid) {
			//console.log('detailsERrorList - checkboxIsValid for ', field, ' = ', this.newAppDetailsStore.checkboxIsValid[field]);
			if(!this.newAppDetailsStore.checkboxIsValid[field]) {
				errorList.push({
					field: field,
					label: this.newAppDetailsStore.checkboxFields[field].label,
					error: this.masterStore.REQUIRED_ERROR,
					path: 'app-details'
				});
				//console.log('detailsERrorList - after checkbox validation - errorList = ', JSON.stringify(errorList));
			}
		}
		if(!this.newAppDetailsStore.releaseDateIsValid) {
			errorList.push({
				field: 'releaseDate',
				label: 'Release date',
				error: this.masterStore.REQUIRED_ERROR,
				path: 'app-details'
			});
		}
		if(!this.newAppDetailsStore.developerChecklistIsValid) {
			errorList.push({
				field: 'fileBrowseButtonEl',
				label: 'Certification form',
				error: this.masterStore.REQUIRED_ERROR,
				path: 'app-details'
			});
		}
		if(!this.newAppDetailsStore.appTypeIsValid) {
			errorList.push({
				field: 'app_type',
				label: 'App type',
				error: this.masterStore.REQUIRED_ERROR,
				path: 'app-details'
			});
		}
		if(!this.newAppDetailsStore.versionNumberIsValid) {
			errorList.push({
				field: 'version',
				label: 'FirstNet App Catalog version',
				error: this.masterStore.VERSION_MISMATCH_ERROR,
				path: 'app-details'
			});
		}
		//console.log('computed detailsErrorList: returned errorList', errorList);
		return errorList;
	}

	@computed get packageErrorList() {
		let errorList = [];
		if(this.newAppDetailsStore.appPackageIsMissing) {
			errorList.push({
				field: 'fileBrowseButtonEl',
				label: 'App package',
				error: 'A file or store link is required.',
				path: 'app-package'
			});
		}
		if(this.newAppDetailsStore.appPackageIsMismatched) {
			errorList.push({
				field: 'fileBrowseButtonEl',
				label: 'App package',
				error: 'File type does not match the selected platform.',
				path: 'app-package'
			});
		}
		return errorList;
	}

	@computed get screenshotsErrorList() {
		let errorList = [];
		if(this.newAppDetailsStore.iconScreensAreMissing) {
			errorList.push({
				field: 'appIconBrowserButton',
				label: 'App icon',
				error: 'An app icon is required.',
				path: 'app-screenshots'
			});
		}
		if(!this.newAppDetailsStore.deviceHasBeenSelected) {
			errorList.push({
				field: 'deviceType',
				label: 'App screenshots',
				error: 'At least one device must be selected.',
				path: 'app-screenshots'
			});
		}
		if(this.newAppDetailsStore.mobileScreensAreMissing) {
			errorList.push({
				field: 'mobileScreenBrowserButton',
				label: 'Mobile screenshots',
				error: 'At least one mobile screenshot is required.',
				path: 'app-screenshots'
			});
		}
		if(this.newAppDetailsStore.tabletScreensAreMissing) {
			errorList.push({
				field: 'tabletScreenBrowserButton',
				label: 'Tablet screenshots',
				error: 'At least one tablet screenshot is required.',
				path: 'app-screenshots'
			});
		}
		this.newAppDetailsStore.mobileScreensMissingDescriptions.forEach((emptyField) => {
			errorList.push({
				field: emptyField,
				label: 'Mobile screenshots',
				error: 'Screenshot requires a description.',
				path: 'app-screenshots'
			});
		});
		this.newAppDetailsStore.tabletScreensMissingDescriptions.forEach((emptyField) => {
			errorList.push({
				field: emptyField,
				label: 'Tablet screenshots',
				error: 'Screenshot requires a description.',
				path: 'app-screenshots'
			});
		});
		return errorList;
	}

	@computed get errorList() {
		let errorList = [].concat(
				this.detailsErrorList,
				this.packageErrorList,
				this.screenshotsErrorList
			)
		const orderedErrorList = []
		errorList.forEach(err => {
			let pos = errorOrders.indexOf(err.label)
			orderedErrorList[pos] = err
		});
		//console.log('computed errorList: ', orderedErrorList);
		// this implementation created empty array indexes, the .filter(idx => idx) removes anything that doesn't exist to avoid errors
		return orderedErrorList.filter(idx => idx);
	}

	@computed get newAppDetailsHasErrors() {
		return Boolean(this.detailsErrorList.length);
	}

	@computed get newAppPackageUploadHasErrors() {
		return Boolean(this.packageErrorList.length);
	}

	@computed get newAppScreenshotUploadHasErrors() {
		return Boolean(this.screenshotsErrorList.length);
	}

	@computed get editAppHasErrors() {
		return Boolean(this.errorList.length);
	}

	@action placeFocus({references, defaultFieldId}) {
    /* It takes time to build the references list by rendering.
    Add timeout so this happens at the end of the rendering queue. */
    setTimeout(() => {
      if (this.errorDestination && references[this.errorDestination]) {
        references[this.errorDestination].focus();
      } else if(references && defaultFieldId && references[defaultFieldId]) {
        references[defaultFieldId].focus();
      }
    }, 0);
  }

	@observable errorDestination = '';
}
